exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.con-vs-chip[data-v-2abf7e51] {\n  min-width: 50px !important;\n  font-size: 0.9rem !important;\n}\r\n", ""]);

// exports
